<template>
  <div>
    <div>
      <v-card class="elevation-1" outlined>
        <v-tabs grow background-color="blue-grey lighten-5">
          <v-tab active-class="active" @click="selectTab('all')">
            <div class="tab-title">
              Tất cả
              <span class="tab-count">({{ statusCount.countAll }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('noContact')">
            <div class="tab-title">
              Chưa chăm sóc
              <span class="tab-count">({{ statusCount.countNoContact }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('appointmentSet')">
            <div class="tab-title">
              Đã đặt lịch hẹn
              <span class="tab-count">({{ statusCount.countAppointmentSet }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('productVerified')">
            <div class="tab-title">
              Đã tư vấn
              <span class="tab-count">({{ statusCount.countProductVerified }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('Succeed')">
            <div class="tab-title">
              Đã nhập học
              <span class="tab-count">({{ statusCount.countSucceed }})</span>
            </div>
          </v-tab>
          <v-tab active-class="active" @click="selectTab('failed')">
            <div class="tab-title">
              Thất bại
              <span class="tab-count">({{ statusCount.countFailed }})</span>
            </div>
          </v-tab>
        </v-tabs>
      </v-card>
      <v-card class="elevation-0" outlined>
        <v-card-text class="py-6 px-6">
          <div style="display: flex; justify-content: flex-end;">
            <v-menu v-model="showColumnSelector" offset-x :close-on-content-click="false">
              <template v-slot:activator="{on}">
                <v-btn outlined v-on="on" color="primary" style="margin-bottom: 24px;">
                  Cấu hình bảng
                </v-btn>
              </template>

              <v-list class="scrollable-menu">
                <v-list-item v-for="(header, index) in headers" :key="index">
                  <v-list-item-action>
                    <v-checkbox v-model="header.show"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>{{ header.text }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-card class="elevation-1" outlined>
            <v-data-table
              item-key="id"
              :headers="visibleHeaders"
              :loading="loading"
              :items="Leads"
              :items-per-page="pagination.itemsPerPage"
              :page.sync="pagination.page"
              :server-items-length="pagination.totalItems"
              :disable-sort="$vuetify.breakpoint.smAndDown"
              :height="400"
              :footer-props="{'items-per-page-text': 'Số khách hàng một trang'}"
              v-bind="this.$attrs"
              fixed-header
              @pagination="updatePagination"
            >
              <template v-slot:[`item.data`]="{item}">
                <div v-if="item.data && Array.isArray(item.data.student)">
                  <div v-for="(student, index) in item.data.student" :key="index">
                    <lead-student-card :student="student" />
                    <v-divider v-if="index < item.data.student.length - 1"></v-divider>
                  </div>
                </div>
                <div v-else>
                  <lead-student-card />
                </div>
              </template>
              <template v-slot:[`item.info`]="{item}">
                <div style="height: 100%;">
                  <lead-info-card :item="item" />
                </div>
              </template>
              <template v-slot:[`item.create`]="{item}">
                <div style="height: 100%;">
                  <lead-create-card :item="item" />
                </div>
              </template>

              <template v-slot:[`item.note`]="{item}">
                <v-tooltip bottom max-width="300px">
                  <template v-slot:activator="{on, attrs}">
                    <div class="ellipsis-text max-width-description" v-bind="attrs" v-on="on">
                      {{ item.note }}
                    </div>
                  </template>
                  <span>{{ item.note }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.activeCodes`]="{item}">
                <div>{{ formatActiveCodes(item.activeCodes) }}</div>
              </template>
              <template v-slot:[`item.products`]="{item}">
                <div>{{ formatProducts(item.products) }}</div>
              </template>
              <template v-slot:[`item.status`]="{item}">
                {{ formatLead(item.status) }}
              </template>
              <template v-slot:[`item.interest`]="{item}">
                {{ formatLead(item.interest) }}
              </template>
              <template v-slot:[`item.segment`]="{item}">
                {{ formatLead(item.segment) }}
              </template>
              <template v-slot:[`footer.page-text`]="items">
                Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
const originHeaders = [
  {
    text: 'Thông tin',
    value: 'info',
    align: 'left',
    sortable: false,
    show: true,
    width: '100'
  },
  {
    text: 'Họ tên',
    value: 'buyerName',
    align: 'left',
    sortable: false,
    show: true,
    width: '150'
  },
  {
    text: 'Học sinh',
    value: 'data',
    align: 'left',
    sortable: false,
    show: true,
    width: '300'
  },
  {
    text: 'Thông tin tạo',
    value: 'create',
    align: 'left',
    sortable: false,
    show: false
  },
  {
    text: 'Nguồn marketing',
    value: 'importOrigin',
    align: 'left',
    sortable: false,
    show: false,
    width: '100'
  },
  {
    text: 'Hệ đào tạo',
    value: 'products',
    align: 'left',
    sortable: false,
    show: false,
    width: '120'
  },
  {
    text: 'Độ quan tâm',
    value: 'interest',
    align: 'left',
    sortable: false,
    show: false,
    width: '80'
  },
  {
    text: 'Phân khúc',
    value: 'segment',
    align: 'left',
    sortable: false,
    show: false,
    width: '100'
  },
  {
    text: 'Mã hồ sơ',
    value: 'activeCodes',
    align: 'left',
    sortable: false,
    show: false,
    width: '110'
  },
  {
    text: 'Ghi chú',
    value: 'note',
    align: 'left',
    sortable: false,
    show: false,
    width: '200'
  },
  {
    text: 'G.Đ chăm sóc',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
    width: '130'
  }
]

import {mapActions} from 'vuex'
import LeadStudentCard from '@/components/basic/card/LeadStudentCard.vue'
import LeadInfoCard from '@/components/basic/card/LeadInfoCard.vue'
import LeadCreateCard from '@/components/basic/card/LeadCreateCard.vue'
import formatLead from '@/helpers/translateLead.js'

export default {
  components: {
    LeadStudentCard,
    LeadInfoCard,
    LeadCreateCard
  },
  computed: {
    visibleHeaders() {
      return this.headers.filter(header => {
        if (header.value === 'status') {
          return this.selectedTab === 'all'
        }
        return header.show
      })
    }
  },
  props: {
    query: Object,
    statusCount: Object
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      showColumnSelector: false,
      selectedTab: 'all',
      activeTab: 0,
      Leads: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      }
    }
  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    ...mapActions('lead', ['fetchLeads', 'countLeads', 'countStatus']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const limit = this.pagination.itemsPerPage
      let queryParams = {
        isArchived: 'false'
      }
      if (this.selectedTab !== 'all') {
        queryParams.status = this.selectedTab
      }

      try {
        this.pagination.totalItems = await this.countLeads({...queryParams, ...this.query})
        this.Leads = await this.fetchLeads({
          _start: start,
          _limit: limit,
          ...queryParams,
          ...this.query,
          inCharge: this.$route.params.id
        })
      } catch (error) {
        this.$alert.error('Lỗi load thông tin khách hàng')
        console.error(error)
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    selectTab(status) {
      this.selectedTab = status
      this.refresh()
    },
    formatActiveCodes(codes) {
      return codes.map(codeObj => codeObj.code).join(', ')
    },
    formatProducts(products) {
      return products.map(product => product.name).join(', ')
    },
    formatLead(data) {
      return formatLead(data)
    }
  },
  watch: {
    'pagination.page'() {
      this.refresh()
    },
    'pagination.itemsPerPage'() {
      this.refresh()
    },
    query(newQuery, oldQuery) {
      if (newQuery !== oldQuery) {
        this.refresh()
      }
    },
    selectedTab(newVal) {
      const statusHeader = this.headers.find(header => header.value === 'status')
      if (statusHeader) {
        statusHeader.show = newVal === 'all'
      }
    }
  }
}
/* eslint-enable no-unused-vars */
</script>
<style>
.clickable-text {
  color: blue;
  cursor: pointer;
}
.scrollable-menu {
  max-height: 300px;
  overflow-y: auto;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.max-width-description {
  max-width: 200px;
}
.active {
  opacity: 1 !important;
  color: #0d47a1 !important;
  background-color: #ffffff !important;
  border: 1px solid lightgrey;
}
.v-tabs-slider {
  color: #0d47a1 !important;
  caret-color: #0d47a1 !important;
}
.tab-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tab-count {
  font-size: smaller; /* Adjust the font size as needed */
  color: grey !important;
}
</style>
